import React, { useCallback, useEffect, useState } from "react";
import { Box } from "@mui/material";
import { login } from "../../services/api";
import Cookies from "js-cookie";
import useSignIn from "react-auth-kit/hooks/useSignIn";
import { getToken } from "firebase/messaging";
import { messaging } from "../../firebase/firebaseConfig";
import colors from "../../theme";
import RSP_LOGO_RG from "../../assets/RSP_LOGO_RG.png";
import { keyframes } from "@emotion/react";
import { useNavigate, useLocation } from "react-router-dom";

const bounce = keyframes`
  0%, 100% { transform: translateY(0); }
  50% { transform: translateY(-10px); }
`;

const DummyPage = () => {
  const navigate = useNavigate();
  const signIn = useSignIn();
  const { search } = useLocation();
  const queryParams = new URLSearchParams(search);
  const chargePointId = queryParams.get("chargePointId");
  const [, setError] = useState("");
  const [, setStatusCode] = useState();
  const [, setOpenSnackbar] = useState(false);
  const [, setFcmToken] = useState("");

  const handleLogin = useCallback(async ({ email, password, fcmToken }) => {
    try {
      await login(
        { email, password, fcmToken },
        navigate,
        signIn,
        setError,
        setOpenSnackbar,
        setStatusCode
      );
      Cookies.set("fcmToken", fcmToken);
    } catch (error) {
      console.error(error);
    }
  }, [navigate, signIn]);

  useEffect(() => {
    const requestPermission = async () => {
      let token;
      try {
        const permission = await Notification.requestPermission();
        if (permission === "granted") {
          if ("serviceWorker" in navigator) {
            try {
              token = await getToken(messaging, {
                vapidKey: process.env.REACT_APP_VAPID_KEY,
              });
              if (token) {
                setFcmToken(token);
              } else {
                console.log("No FCM Token received");
              }
            } catch (tokenError) {
              console.error("Error getting FCM token:", tokenError);
            }
          } else {
            console.error("Service Worker is not supported in this browser");
          }
        } else if (permission === "denied") {
          console.log("Notification permission denied");
        } else {
          console.log("Notification permission request dismissed");
        }
      } catch (error) {
        console.error("Error during notification permission request:", error);
      }

      if (chargePointId === "9E0E85720-0") {
        handleLogin({
          email: "readysteadyplug@yopmail.com",
          password: "Password@1",
          fcmToken: token || "",
        });
      } else if (chargePointId === "9E0EAB4BC-0") {
        handleLogin({
          email: "readysteadyplug1@yopmail.com",
          password: "Password@1",
          fcmToken: token || "",
        });
      } else if (chargePointId === "9E0EAB4BC-1") {
        handleLogin({
          email: "readysteadyplug2@yopmail.com",
          password: "Password@1",
          fcmToken: token || "",
        });
      } else if (chargePointId === "E6E3F5DF8-0") {
        handleLogin({
          email: "rsptest3@yopmail.com",
          password: "Password@1",
          fcmToken: token || "",
        });
      }
    };

    requestPermission();
  }, [chargePointId, handleLogin]);

  return (
    <>
      <Box sx={{ height: "100vh", bgcolor: colors.mainContentBgColor }}>
        <Box>
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              flexDirection: "column",
              height: "100vh",
            }}
          >
            <Box
              sx={{
                display: "flex",
                alignItems: "center",
                my: 5,
              }}
            >
              <Box
                sx={{
                  width: 8,
                  height: 8,
                  bgcolor: colors.primary,
                  borderRadius: "50%",
                  marginX: 0.5,
                  animation: `${bounce} 0.6s infinite`,
                  animationDelay: "0s",
                }}
              />
              <Box
                sx={{
                  width: 8,
                  height: 8,
                  bgcolor: colors.primary,
                  borderRadius: "50%",
                  marginX: 0.5,
                  animation: `${bounce} 0.6s infinite`,
                  animationDelay: "0.2s",
                }}
              />
              <Box
                sx={{
                  width: 8,
                  height: 8,
                  bgcolor: colors.primary,
                  borderRadius: "50%",
                  marginX: 0.5,
                  animation: `${bounce} 0.6s infinite`,
                  animationDelay: "0.4s",
                }}
              />
            </Box>

            <Box>
              <img
                src={RSP_LOGO_RG}
                alt="RSP Logo"
                width={188.832}
                height={30}
              />
            </Box>

            <Box sx={{ mt: 2 }}>Please enable notifications</Box>
          </Box>
        </Box>
      </Box>
    </>
  );
};

export default DummyPage;
